<template>
  <div class="main-content-container">
    <div class="container">
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">cadastros internos</span>
          <h3 class="page-title">Tabela de Segmentos</h3>
        </div>
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <input
              type="text"
              class="form-control form-control-sm mt-3"
              style="max-width: 220px"
              placeholder="Pesquisar por nome..."
              v-model="filtroNome"
              @keyup.enter="Pesquisar()"
            />
            <button type="button" class="btn btn-primary btn-sm mt-3 ml-1" @click="Pesquisar()">
              <i class="fas fa-search"></i>
            </button>
            <button
              v-if="filtroNome"
              type="button"
              class="input-group-text btn-sm mt-3 ml-1"
              v-b-tooltip.hover.bottom
              title="Limpar filtro"
              @click="LimparFiltro()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Segmentos</h6>
              </div>
              <div class="float-right" v-if="pagination.TotalItems > 0">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? "itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Nome</th>
                    <th scope="col" class="border-0">Situação</th>
                    <th scope="col" class="border-0">Data de criação</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="segmento in segmentos" :key="segmento.Id">
                    <td></td>
                    <td class="text-left">{{ segmento.Nome }}</td>
                    <td>
                      <span :class="segmento.Ativo ? 'badge badge-success' : 'badge badge-danger'">
                        {{ segmento.Ativo ? "Ativo" : "Inativo" }}
                      </span>
                    </td>
                    <td>{{ segmento.DataCriacao | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" v-on:click.prevent="Abrir(segmento, true)">
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a class="dropdown-item" href="#" v-on:click.prevent="Abrir(segmento)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a class="dropdown-item" href="#" v-on:click.prevent="ConfirmarToggle(segmento)">
                            <i :class="segmento.Ativo ? 'fas fa-ban mr-2' : 'fas fa-check-circle mr-2'"></i>
                            {{ segmento.Ativo ? "Desativar" : "Reativar" }}
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="segmentos.length === 0">
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="segmentos-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="sm" id="mFormSegmento" :title="modalTitle" :no-close-on-backdrop="true" :no-close-on-esc="false">
      <ValidationObserver tag="form" ref="formValidado">
        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Nome</label>
            <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
              <d-form-input
                type="text"
                v-model="item.Nome"
                :class="formValidado | showValidateError(invalid)"
                :disabled="isVisualizando"
              />
              <div class="invalid-feedback d-block" v-if="formValidado">{{ errors[0] }}</div>
            </ValidationProvider>
          </d-col>
        </d-form-row>
      </ValidationObserver>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          v-if="!isVisualizando"
          size="sm"
          variant="success"
          @click="Salvar()"
          :disabled="loadingAddUpdate"
        >
          <template v-if="!loadingAddUpdate">
            {{ itemOriginal ? "Salvar" : "Adicionar" }} <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo segmento"
      v-on:click.prevent="Abrir()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "segmentos",
  data() {
    return {
      loadingList: false,
      loadingAddUpdate: false,
      modalTitle: "Novo segmento",
      filtroNome: "",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      segmentos: [],
      item: { Nome: "" },
      itemOriginal: null,
      isVisualizando: false,
      formValidado: false
    };
  },
  watch: {
    "pagination.PageNumber": function() {
      this.Carregar();
    },
    "pagination.RowsPerPage": function() {
      this.pagination.PageNumber = 1;
      this.Carregar();
    }
  },
  mounted() {
    this.Carregar();
  },
  methods: {
    Carregar() {
      this.loadingList = true;
      const params = {
        PageNumber: this.pagination.PageNumber,
        RowsPerPage: this.pagination.RowsPerPage,
        "Object.Nome": this.filtroNome || undefined
      };
      this.$store.dispatch("ListSegmentosPage", { params })
        .then(response => {
          this.segmentos = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao carregar segmentos", error);
        })
        .finally(() => { this.loadingList = false; });
    },
    Pesquisar() {
      this.pagination.PageNumber = 1;
      this.Carregar();
    },
    LimparFiltro() {
      this.filtroNome = "";
      this.pagination.PageNumber = 1;
      this.Carregar();
    },
    Abrir(segmento, ver) {
      this.formValidado = false;
      this.isVisualizando = !!ver;
      if (!segmento) {
        this.itemOriginal = null;
        this.item = { Nome: "" };
        this.modalTitle = "Novo segmento";
      } else {
        this.itemOriginal = segmento;
        this.item = { Id: segmento.Id, Nome: segmento.Nome };
        this.modalTitle = ver ? "Detalhes do segmento" : "Editar segmento";
      }
      this.$bvModal.show("mFormSegmento");
    },
    Salvar() {
      this.formValidado = true;
      this.$refs.formValidado.validate().then(isValid => {
        if (!isValid) return;
        this.loadingAddUpdate = true;
        const acao = this.itemOriginal
          ? this.$store.dispatch("UpdateSegmento", this.item)
          : this.$store.dispatch("CadastrarSegmento", this.item.Nome);
        acao
          .then(() => {
            const msg = this.itemOriginal ? "Segmento atualizado com sucesso." : "Segmento cadastrado com sucesso.";
            const titulo = this.itemOriginal ? "Segmento atualizado" : "Segmento cadastrado";
            this.$makeToast(msg, "success", titulo);
            this.Carregar();
            this.$bvModal.hide("mFormSegmento");
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao salvar o segmento", error);
          })
          .finally(() => { this.loadingAddUpdate = false; });
      });
    },
    ConfirmarToggle(segmento) {
      const acao = segmento.Ativo ? "desativar" : "reativar";
      this.$makeMsgBox(
        `Você tem certeza que deseja ${acao} "${segmento.Nome}"?`,
        `Confirmar`,
        this.ToggleAtivo,
        segmento.Id
      );
    },
    ToggleAtivo(id) {
      this.loadingList = true;
      this.$store.dispatch("DeleteSegmento", id)
        .then(novoAtivo => {
          const msg = novoAtivo ? "Segmento reativado com sucesso." : "Segmento desativado com sucesso.";
          const titulo = novoAtivo ? "Segmento reativado" : "Segmento desativado";
          this.$makeToast(msg, "success", titulo);
          this.Carregar();
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Não foi possível alterar o segmento", error);
        })
        .finally(() => { this.loadingList = false; });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/segmentos.vue